// extracted by mini-css-extract-plugin
export var actions = "_6r-8";
export var arrow = "_6r-5";
export var card = "_6r-0";
export var cardWrapper = "_6r-9";
export var fieldName = "_6r-3";
export var newValue = "_6r-6";
export var oldValue = "_6r-4";
export var orangeGlowFade = "_6r-c";
export var productSection = "_6r-1";
export var scrollToBottom = "_6r-b";
export var scrollToBottomAnchor = "_6r-a";
export var scrollToBottomIcon = "_6r-d";
export var showAllButton = "_6r-7";
export var table = "_6r-2";